export default {
  page: {
    title: {
      base: 'Πύλη πληρωμής Autopay',
      start: 'Επιλογή τρόπου πληρωμής',
      result: 'Επαναλαμβανόμενη πληρωμή BLIK',
      visadata: 'Πληρωμή VisaMobile',
      continue: 'Συνέχεια - Επιλογή τρόπου πληρωμής',
      wait: 'Αναμονή',
      confirmation: 'Επιβεβαίωση πληρωμής',
      thankYou: 'Ευχαριστώ για την πληρωμή',
      error: 'Σφάλμα σελίδας',
      errorNotFound: 'Η σελίδα δεν βρέθηκε',
      secureBack: 'Φόρτωση σελίδας',
      maintenance: 'Σελίδα υπό συντήρηση',
      regulationsApproval: 'Κανονισμοί και Πολιτική Απορρήτου',
      toTransferData: 'Στοιχεία τραπεζικής μεταφοράς',
      sessionTimeout: 'Σελίδα μετά το τέλος της σύνδεσης',
      paywayError: 'Το κανάλι πληρωμής δεν είναι διαθέσιμο'
    }
  },
  header: {
    availabilityAdjust: {
      increaseFontSize: 'Αυξήστε το μέγεθος της γραμματοσειράς',
      decreaseFontSize: 'Μειώστε το μέγεθος της γραμματοσειράς',
      changeContrast: 'Αλλάξτε την αντίθεση',
      changeLanguage: 'Αλλάξτε τη γλώσσα της σελίδας',
      skipToContent: 'Μετάβαση στο περιεχόμενο',
      skipToContentLabel: 'Μετάβαση στο κύριο περιεχόμενο',
      logoTitle: 'Πύλη πληρωμής Autopay',
      langLoading: 'Φόρτωση γλώσσας',
      langChanged: 'Η γλώσσα άλλαξε'
    },
    sessionTimer: {
      timeOut: 'Η σύνδεση έχει λήξει',
      sessionEnd: 'Λήξη σύνδεσης σε:',
      label: 'Επεκτείνετε τον χρόνο της συνεδρίας σας',
      button: 'Επεκτείνω'
    }
  },
  footer: {
    text1: 'Έχετε επιπλέον ερωτήσεις σχετικά με τις ηλεκτρονικές πληρωμές ή τις άλλες υπηρεσίες μας; <a title="Ανοίγει σε νέο παράθυρο" href="https://pomoc.autopay.pl/?pk_campaign=paywall&pk_kwd=start&pk_medium=hyperlink" class="footer-text-link" target="_blank" rel="noreferrer">Μεταβείτε στη σελίδα Βοήθειας</a>',
    text2: {
      part1: 'Ο διαχειριστής των προσωπικών δεδομένων είναι η Autopay S.A.',
      part2: 'οδ. Powstańców Warszawy 6, 81-718 Sopot. Η παροχή προσωπικών δεδομένων είναι εθελοντική, αλλά απαραίτητη για τη συμπλήρωση της υποβληθείσας αίτησης. Η νομική βάση, ο σκοπός, η περίοδος επεξεργασίας προσωπικών δεδομένων και τα δικαιώματα του χρήστη καθώς και άλλες σημαντικές πληροφορίες σχετικά με τις αρχές της επεξεργασίας προσωπικών δεδομένων ορίζονται αναλυτικά στο<a href="{privacyPolicyUrl}" class="footer-text-link" target="_blank" title="Μεταβείτε στη σελίδα με το έγγραφο Πολιτικής Απορρήτου (128 KB, PDF)" rel="noreferrer">την Πολιτική Απορρήτου της Autopay S.A.</a>'
    },
    linkShowMoreTitle: 'Προβολή επιπλέον πληροφοριών',
    linkShowMoreText: 'Διαβάστε περισσότερα',
    linkShowLessTitle: 'Απόκρυψη επιπλέον πληροφοριών',
    linkShowLessText: 'Διαβάστε λιγότερα'
  },
  paywall: {
    header: 'Επιλέξτε μέθοδο πληρωμής',
    info: {
      paywayNotAvailable: 'Λυπούμαστε, αλλά φαίνεται ότι η επιλεγμένη μέθοδος πληρωμής δεν είναι διαθέσιμη αυτή τη στιγμή στη συσκευή σας.',
      applePayNotAvailable: 'Λυπούμαστε, αλλά φαίνεται ότι η πληρωμή με Apple Pay δεν είναι διαθέσιμη αυτή τη στιγμή στη συσκευή σας.',
      googlePayNotAvailable: 'Λυπούμαστε, αλλά φαίνεται ότι η πληρωμή με Google Pay δεν είναι διαθέσιμη αυτή τη στιγμή στη συσκευή σας.'
    },
    paywayGroup: {
      inactiveMessage: 'Η πληρωμή δεν είναι διαθέσιμη αυτή τη στιγμή',
      notice: {
        novelty: 'ΝΕΟ',
        promotion: 'ΠΡΟΩΘΗΣΗ',
        recommended: 'ΣΥΝΙΣΤΑΤΑΙ',
        mastercard: 'ΓΡΗΓΟΡΑ ΚΑΙ ΑΣΦΑΛΕΙΑ',
        mastercardC2P: 'ΓΡΗΓΟΡΑ ΚΑΙ ΑΣΦΑΛΕΙΑ',
        blik: 'BLIKOMANIA – εγγραφείτε και κερδίστε διαμάντια!',
        visaMobile: 'Πληρώστε εύκολα και με ασφάλεια'
      },
      bank: {
        many: 'τραπεζών ',
        one: 'τράπεζα ',
        two: 'τράπεζες '
      },
      wallet: {
        many: 'πορτοφολιών ',
        one: 'πορτοφόλι ',
        two: 'πορτοφόλια '
      },
      otp: {
        many: 'τρόπων ',
        one: 'τρόπος ',
        two: 'τρόποι '
      },
      blikPayLater: {
        text1: 'Αγοράστε τώρα, πληρώστε σε 30 ημέρες – χωρίς επιπλέον κόστος. Με την εισαγωγή του κωδικού BLIK μπορείτε να λάβετε όριο αγορών έως 4.000 PLN.',
        text2: 'Η υπηρεσία είναι διαθέσιμη σε:'
      },
      blikAuto: {
        bankList: 'Υπηρεσία διαθέσιμη σε:',
        infoModel0: 'Οι επόμενες πληρωμές θα χρεώνονται αυτόματα από τον λογαριασμό σας.',
        infoModelM: 'Οι επόμενες πληρωμές θα απαιτούν μόνο επιβεβαίωση στην εφαρμογή της τράπεζάς σας.'
      }
    },
    paywayList: {
      label: 'Ομάδα τύπων πληρωμής',
      linkSelectOther: 'Επιλέξτε άλλο '
    },
    paywaySingle: {
      accountAtAnotherBank: 'Έχω λογαριασμό σε άλλη τράπεζα '
    },
    paywaySwitch: {
      methodShortSingle: 'Μία φορά ',
      methodLongSingle: 'Μοναδικές πληρωμές ',
      methodShortAuto: 'Επαναλαμβανόμενη ',
      methodLongAuto: 'Επαναλαμβανόμενες πληρωμές '
    },
    form: {
      payway: {
        label: 'Επιλέξτε πληρωμή '
      },
      card: {
        label: 'Εισαγάγετε τα στοιχεία της κάρτας ',
        flowLabel: 'Κάρτα πληρωμής',
        iframe: {
          title: 'Φόρμα για συμπλήρωση στοιχείων πιστωτικής κάρτας '
        }
      },
      visaMobile: {
        flowLabel: 'Αριθμός τηλεφώνου',
        iframe: {
          title: 'Φόρμα για συμπλήρωση αριθμού τηλεφώνου '
        },
        status: {
          pending: {
            statusText: 'Αναμονή επιβεβαίωσης ',
            header: 'Επιβεβαιώστε την πληρωμή στην εφαρμογή',
            descriptionText1: 'Επιβεβαιώστε την πληρωμή στην εφαρμογή Visa Mobile ή στην τραπεζική εφαρμογή με ενεργοποιημένη την υπηρεσία Visa Mobile ',
            descriptionText2: 'Μετά την επιβεβαίωση της συναλλαγής στην εφαρμογή, περιμένετε για το αποτέλεσμα της πληρωμής ',
            descriptionText3: 'Η ακύρωση της συναλλαγής είναι σε εξέλιξη ',
            cancelButton: 'Ακύρωση πληρωμής '
          },
          success: {
            statusText: 'Σας ευχαριστούμε για την αγορά',
            descriptionText: 'Η πληρωμή ολοκληρώθηκε επιτυχώς '
          },
          error: {
            statusText: 'Βεβαιωθείτε ότι έχετε επαρκή κεφάλαια στην κάρτα πληρωμής που χρησιμοποιήθηκε για την πληρωμή Visa Mobile.',
            descriptionText: 'Η πληρωμή απορρίφθηκε '
          }
        },
        apps: 'Εφαρμογές που υποστηρίζουν πληρωμές Visa Mobile ',
        help: 'Χρειάζεστε βοήθεια ?',
        info: 'Μάθετε περισσότερα ',
        secure: 'Ασφαλής πληρωμή χάρη στην κρυπτογράφηση SSL ',
        modal2: {
          header: 'Για να επιβεβαιώσετε την πληρωμή, ανοίξτε την εφαρμογή Visa Mobile ή την τραπεζική εφαρμογή με ενεργοποιημένη την υπηρεσία Visa Mobile ',
          listText1: 'έχετε εγκατεστημένη την εφαρμογή Visa Mobile ή ενεργοποιημένη την υπηρεσία Visa Mobile στην τραπεζική σας εφαρμογή ',
          listText2: 'έχετε ενεργοποιήσει τις ειδοποιήσεις στην εφαρμογή Visa Mobile ή στην τραπεζική εφαρμογή με ενεργοποιημένη την υπηρεσία Visa Mobile',
          listText3: 'ο αριθμός που δώσατε είναι σωστός: <strong class="no-wrap">+{prefix} {phone}</strong>',
          listText4: 'Βεβαιωθείτε επίσης ότι... '
        }
      },
      click2pay: {
        loaderText: 'Αναζητούμε τη διεύθυνση e-mail σας<br> σε <strong>Κάντε κλικ για πληρωμή</strong>',
        saveCard: {
          text1: 'Αποθηκεύστε την κάρτα σας',
          text2mc: 'Τα δεδομένα σας θα αποθηκευτούν με ασφάλεια <strong>Mastercard Κάντε κλικ για πληρωμή</strong>',
          text2visa: 'Τα δεδομένα σας θα αποθηκευτούν με ασφάλεια στο <strong>Visa Κάντε κλικ για πληρωμή</strong>',
          link: 'Μάθετε περισσότερα'
        },
        email: {
          labelForClick2Pay: 'Διεύθυνση email για ειδοποιήσεις πληρωμής'
        },
        cardSelect: {
          selected: 'Επιλεγμένο',
          select: 'Επιλέγω',
          payOther: 'Εισαγάγετε τα στοιχεία της κάρτας σας',
          back: 'Πίσω'
        },
        cardSelected: {
          header: 'Χρησιμοποιήστε μια κάρτα που είναι αποθηκευμένη στο Κάντε κλικ για πληρωμή',
          date: 'ισχύει μέχρι',
          buttonChange: 'Αλλαγή'
        },
        codeForm: {
          description: 'Βρήκαμε τη διεύθυνση email σας στο Click to Pay.',
          codeSentEmail: 'Εισαγάγετε τον κωδικό μιας χρήσης που στείλαμε στη διεύθυνση {email} για να συνδεθείτε στον λογαριασμό σας.',
          codeSentPhone: 'Εισαγάγετε τον εφάπαξ κωδικό SMS που στείλαμε στο {phone} για να συνδεθείτε στον λογαριασμό σας.',
          codeSent: 'Εισαγάγετε τον κωδικό μιας χρήσης που στείλαμε στο {validationChannel} για να συνδεθείτε στον λογαριασμό σας.',
          codeLabel: 'Εισαγάγετε κωδικό',
          codePlaceholder: 'εισάγετε κωδικό',
          codeLabelFlow: 'Κώδικας',
          codeSendLabel: 'Αποστολή νέου κωδικού',
          codeSendAriaLabel: 'μέσω',
          codeSendAriaLabel2: 'ή',
          buttonSendNewSms: 'SMS',
          buttonSendNewEmail: 'email',
          trustedLabel: 'Προσθέστε αυτήν τη συσκευή στη λίστα αξιόπιστων<br> <span>Την επόμενη φορά θα αναγνωρίσουμε αυτήν τη συσκευή και θα πληρώσετε χωρίς να συνδεθείτε</span>',
          buttonSubmit: 'Επόμενος',
          buttonChangeCard: 'Εισαγάγετε τα στοιχεία της κάρτας σας'
        },
        info: {
          description: 'Η πληρωμή με κάρτα είναι κρυπτογραφημένη και ασφαλής. Η συναλλαγή θα εγκριθεί χρησιμοποιώντας το 3DSecure στον ιστότοπο της τράπεζας.'
        },
        loginForm: {
          emailLabel: 'Εισαγάγετε τη διεύθυνση email σας για να συνδεθείτε στο Κάντε κλικ για πληρωμή',
          emailPlaceholder: 'διεύθυνση ηλεκτρονικού ταχυδρομείου',
          emailLabelFlow: 'Διεύθυνση email',
          buttonSubmit: 'Συνδεθείτε',
          buttonBack: 'Πίσω'
        },
        newUserForm: {
          header: 'Αποθήκευση κάρτας στο Κάντε κλικ για πληρωμή',
          description: 'Χρειαζόμαστε μερικές ακόμη λεπτομέρειες για να αποθηκεύσουμε την κάρτα σας.',
          emailLabel: 'Εισαγάγετε τη διεύθυνση email',
          emailPlaceholder: 'διεύθυνση ηλεκτρονικού ταχυδρομείου',
          emailLabelFlow: 'Διεύθυνση email',
          countryLabel: 'Χώρα',
          firstnameLabel: 'Ονομα',
          firstnamePlaceholder: 'όνομα',
          firstnameLabelFlow: 'Ονομα',
          lastnameLabel: 'Επώνυμο',
          lastnamePlaceholder: 'επώνυμο',
          lastnameLabelFlow: 'Επώνυμο',
          phoneLabel: 'Αριθμός τηλεφώνου',
          phonePlaceholder: 'αριθμός τηλεφώνου',
          phoneLabelFlow: 'Τηλέφωνο',
          countryCodePlaceholder: 'κώδικας',
          countryCodeLabelFlow: 'Κώδικας',
          trustedLabel: 'Προσθέστε αυτήν τη συσκευή στη λίστα αξιόπιστων<br><span>Την επόμενη φορά θα αναγνωρίσουμε αυτήν τη συσκευή και θα πληρώσετε χωρίς να συνδεθείτε</span>',
          termsMastercardLabel: 'Συνεχίζοντας, αποδέχεσαι <a href="https://www.mastercard.com/global/click-to-pay/country-listing/terms.html" target="_blank">Όροι Χρήσης</a> και κατανοείτε ότι τα δέδοματα σας θα υποβληθούν σε επεξεργασία σύμφωνα με την <a href="https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html" target="_blank">Πολιτική απορρήτου</a> MasterCard.',
          termsVisaLabel: 'Συνεχίζοντας, αποδέχεστε το <a href="{c2pVisaTermsUrl}" target="_blank">Όροι Παροχής Υπηρεσιών Visa Solution</a> και κατανοήστε ότι τα δέδοματα σας θα υποβληθούν σε επεξεργασία σύμφωνα με την <a href="{c2pVisaPrivacyUrl}" target="_blank">Πολιτική Απορρήτου Visa</a>.',
          cookieVisaLabel: 'Συνεχίζοντας, αποδέχεστε το <a href="{c2pVisaCookieUrl}" target="_blank">Πολιτική Cookie Visa</a>.',
          c2pInfo: 'Το email ή ο αριθμός του κινητού σας θα χρησιμοποιηθεί για την επαλήθευση σας. Ενδέχεται να ισχύουν χρεώσεις μηνυμάτων/δεδομένων.',
          buttonSubmit: 'Αποθήκευση και πληρωμή',
          buttonBack: 'Πληρώστε χωρίς να αποθηκεύσετε την κάρτα σας'
        },
        profile: {
          header: 'Συνδεθείτε για να κάνετε κλικ για πληρωμή',
          buttonChangeEmail: 'Αλλαγή διεύθυνσης email'
        },
        modal: {
          title: 'Κάντε κλικ για πληρωμή - πληροφορίες',
          header: 'Πληρώστε γρήγορα και με ασφάλεια χωρίς να εισαγάγετε ξανά τα στοιχεία της κάρτας σας στο νέο πρότυπο Click to Pay',
          text1: 'Όταν πληρώνετε με κάρτα, αναζητήστε το λογότυπο <img src="/web/img/click2pay/Click_to_Pay.svg" style="height: 14px" alt="Κάντε κλικ στο λογότυπο για πληρωμή"> και πληρώστε με την πληρωμή της κάρτας σας γρήγορα και άνετα.',
          text2: 'Το Click To Pay είναι ένα νέο πρότυπο πληρωμής με κάρτα που υποστηρίζεται από τις Visa και Mastercard.',
          text3: 'Μπορείτε να χρησιμοποιήσετε την κάρτα στον λογαριασμό σας Click to Pay για να πληρώσετε σε καταστήματα στην Πολωνία και στο εξωτερικό, χωρίς να εισαγάγετε ξανά τα στοιχεία της κάρτας σας.',
          text4: 'Τα δεδομένα αποθηκεύονται με ασφάλεια σε Visa ή Mastercard. Όλες οι πληροφορίες είναι πλήρως κρυπτογραφημένες.',
          text5: 'Κατά τις μελλοντικές πληρωμές, το Click to Pay θα αναγνωρίσει τη διεύθυνση e-mail σας, ώστε να μπορείτε να πληρώνετε άμεσα με τις αποθηκευμένες κάρτες σας.',
          text6: 'Επιβεβαιώνετε επιπλέον όλες τις πληρωμές με την τράπεζά σας, γεγονός που εγγυάται πλήρη ασφάλεια.',
          processError: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία της πληρωμής σας "Κλικ για πληρωμή". Κάντε μια τυπική πληρωμή με κάρτα.'
        }
      },
      email: {
        label: 'Καταχωρήστε τη διεύθυνση ηλεκτρονικού ταχυδρομείου',
        flowLabel: 'Διεύθυνση email',
        tip: 'Χρειαζόμαστε τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας ώστε να μπορούμε να σας στέλνουμε μηνύματα σχετικά με την κατάσταση των πληρωμών σας.',
        fuse: 'Βεβαιωθείτε ότι η διεύθυνση email σας έχει εισαχθεί σωστά.'
      },
      blikCode: {
        label: 'Εισάγετε τον κωδικό BLIK',
        flowLabel: 'Κωδικός BLIK'
      },
      terms: {
        header: 'Συναινέσεις και δηλώσεις',
        selectAll: 'Επιλογή όλων',
        fieldNotRequired: 'Το πεδίο δεν είναι υποχρεωτικό',
        partnerMarketingTextLess: 'Θα θέλατε να σας στέλνουμε ειδοποιήσεις μέσω email, SMS ή τηλεφώνου σχετικά με τις καλύτερες προσφορές, προωθητικές ενέργειες, διαγωνισμούς και άλλες ενδιαφέρουσες εκδηλώσεις που διοργανώνονται από εμάς ή τους εταίρους μας;',
        partnerMarketingTextMore: 'Υποσχόμαστε να μην χρησιμοποιούμε spam! Αν τα μηνύματά μας σας ενοχλούν, μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή.',
        tradeMarketingTextLess: 'Θα θέλατε να διαβιβάσουμε τη διεύθυνση του ηλεκτρονικού ταχυδρομείου ή τον αριθμό τηλεφώνου σας στους έμπιστους εταίρους μας, ώστε να σας παρουσιάζουν ενδιαφέρουσες πληροφορίες και προσφορές;',
        tradeMarketingTextMore: 'Σας διαβεβαιώνουμε ότι οι εταίροι μας είναι αναγνωρισμένες εταιρείες στις οποίες, όπως και σε εμάς, δεν αρέσει το spamming ενώ μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή.'
      },
      termsFlowLabel: 'Κανονισμοί',
      termsLabelDefault: 'Έχω διαβάσει και συμφωνώ με το <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Κατεβάστε το αρχείο των όρων παροχής υπηρεσιών" rel="noreferrer">Όροι υπηρεσίας πληρωμής</a> και το <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Κάντε λήψη του αρχείου πολιτικής απορρήτου Autopay S.A.">Πολιτική Απορρήτου</a>. Θέλω η υπηρεσία να εκτελεστεί άμεσα και σε περίπτωση υπαναχώρησης από τη σύμβαση, γνωρίζω ότι δεν θα λάβω επιστροφή των εξόδων που πραγματοποιήθηκαν για τις υπηρεσίες που παρέχονται, κατόπιν αιτήματός μου, πριν από την υπαναχώρησή μου από τη σύμβαση.',
      termsReccuring: 'Εάν επιθυμείτε να πραγματοποιήσετε πληρωμή, αποδεχτείτε το<a href="{regulationUrl}" class="form-text-link" target="_blank" title="Κατεβάστε το αρχείο των όρων παροχής υπηρεσιών" rel="noreferrer"> Όροι παροχής υπηρεσιών</a>και<a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Κάντε λήψη του αρχείου πολιτικής απορρήτου Autopay S.A.">Πολιτική Απορρήτου</a>Autopay S.A., συναίνεση για άμεση εξυπηρέτηση πληρωμών και συγκατάθεση για χρέωση της κάρτας πληρωμής μου.',
      termsReccuringMore1: 'Συμφωνώ ότι η υπηρεσία θα παρασχεθεί χωρίς καθυστέρηση και, σε περίπτωση υπαναχώρησης, γνωρίζω ότι δεν θα αποζημιωθώ για τις υπηρεσίες που παρασχέθηκαν κατόπιν αιτήματός μου έως ότου υπαναχωρήσω από τη σύμβαση.',
      termsReccuringMore2: 'Με το παρόν συναινώ η κάρτα πληρωμής μου να χρεώνεται σε επαναλαμβανόμενη βάση από την Autopay S.A.. για την πραγματοποίηση της συναλλαγής προς όφελος του {receiverName}. Οι όροι της επαναλαμβανόμενης χρέωσης της κάρτας ορίζονται από το<a href="{regulationUrl}" class="form-text-link" target="_blank" title="Κατεβάστε το αρχείο των όρων παροχής υπηρεσιών" rel="noreferrer"> Όροι υπηρεσίας πληρωμής</a>. Δια του παρόντος δηλώνω ότι γνωρίζω τις περιόδους, τη συχνότητα και τους κανόνες καθορισμού των ποσών χρέωσης στην κάρτα πληρωμής μου καθώς και τον τρόπο ανάκλησης αυτής της συγκατάθεσης, που έχουν καθοριστεί από εμένα με {receiverName}. Θα επικοινωνήσω με τον {receiverName} για τυχόν ερωτήσεις σχετικά με την επαναλαμβανόμενη χρέωση στην κάρτα πληρωμής.',
      mwfClauseLess: 'Εάν θέλετε να κάνετε μια πληρωμή, αποδεχτείτε το<a href="{regulationUrl}" class="form-text-link" target="_blank" title="Κατεβάστε το αρχείο με τους Όρους Παροχής Υπηρεσιών" rel="noreferrer">όρους και προϋποθέσεις</a>και<a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title=" Κατεβάστε το αρχείο με την Πολιτική Απορρήτου Autopay S.A.">πολιτική απορρήτου της Autopay S.A.</a>, συναινείτε να ξεκινήσετε μια συναλλαγή στην τράπεζά σας μέσω της Autopay S.A. και παρέχετε λεπτομέρειες αυτής της συναλλαγής στον παραλήπτη και ζητήστε την άμεση εκτέλεση της υπηρεσίας πληρωμής.',
      mwfClauseMore: 'Θέλω η υπηρεσία να παρασχεθεί άμεσα και γνωρίζω ότι δεν θα μου επιστραφούν τα δαπανηθέντα χρήματα σε περίπτωση υπαναχώρησης από τη σύμβαση.',
      mwfClauseARIA: 'Εάν θέλετε να πραγματοποιήσετε μια πληρωμή, αποδεχτείτε τους όρους και τις προϋποθέσεις και την πολιτική απορρήτου της Autopay S.A., συναινέστε να ξεκινήσετε μια συναλλαγή στην τράπεζά σας μέσω της Autopay S.A. και παρέχετε λεπτομέρειες αυτής της συναλλαγής στον παραλήπτη και ζητήστε την άμεση εκτέλεση της υπηρεσίας πληρωμής. Θέλω να παρέχεται η υπηρεσία άμεσα και γνωρίζω ότι δεν θα λάβω επιστροφή των δαπανών που πραγματοποιήθηκαν σε περίπτωση υπαναχώρησης από τη σύμβαση.<a href="{regulationUrl}" class="form-text-link" target="_blank" title="" rel="noreferrer" tabindex="-1">Κατεβάστε το αρχείο με τους Όρους Παροχής Υπηρεσιών</a> <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="" tabindex="-1">Κατεβάστε το αρχείο με την Πολιτική Απορρήτου Autopay S.A.</a>',
      paymentInfo: 'Η εντολή πληρωμής υποβάλλεται στην τράπεζά σας μέσω της Autopay S.A., με έδρα το Σόποτ, και θα διεκπεραιωθεί σύμφωνα με τους όρους που ορίζει η τράπεζά σας. Αφού επιλέξετε την τράπεζά σας, θα εγκρίνετε την πληρωμή.',
      changePaywayLink1: 'Μπορείτε ακόμα ',
      changePaywayLink2: 'να αλλάξετε τη μέθοδο πληρωμής ',
      linkMore: 'ΠΕΡΙΣΣΟΤΕΡΑ',
      linkShowMoreTitle: 'Εμφάνιση επιπλέον πληροφοριών ',
      linkLess: 'ΛΙΓΟΤΕΡΑ ',
      linkShowLessTitle: 'Απόκρυψη επιπλέον πληροφοριών ',
      submitButton: {
        visaMobile: 'Πληρώστε μέσω ',
        fastTransfer: 'Δημιουργία στοιχείων για μεταφορά ',
        mwf: 'Αποδέχομαι και πληρώνω ',
        pis: 'Αποδέχομαι και ξεκινώ την πληρωμή ',
        auto: 'Ανάθεση επαναλαμβανόμενης πληρωμής',
        autoPayment: 'Ανάθεση πληρωμής ',
        other: 'Πληρώνω ',
        orange: 'Επιβεβαίωση ',
        c2pNext: 'Επόμενο ',
        c2pAccept: 'Αποδέχομαι ',
        c2pSaveAndPay: 'Αποθηκεύστε και πληρώστε ',
        ariaLabelInactive: 'Για να συνεχίσετε, συμπληρώστε σωστά τα υποχρεωτικά πεδία'
      }
    },
    frData: {
      pageTitle: 'Αναλυτικά στοιχεία μεταφοράς ',
      header: 'Εκτελέστε μεταφορά χρησιμοποιώντας τα δεδομένα ',
      nrbLabel: 'Λογαριασμός παραλήπτη ',
      nameLabel: 'Όνομα παραλήπτη ',
      addressLabel: 'Διεύθυνση παραλήπτη ',
      titleLabel: 'Τίτλος μεταφοράς',
      amountLabel: 'Ποσό μεταφοράς',
      timeLabel: 'Ολοκληρώστε τη συναλλαγή μέχρι ',
      linkCopy: 'Αντιγραφή',
      linkGetPdf: 'Λήψη PDF με τα δεδομένα',
      linkGetPdfTitle: 'Ανοίγει σε νέο παράθυρο',
      linkGoToBank: 'Συνδεθείτε στην τράπεζα ',
      info: 'Συνδεθείτε στον τραπεζικό σας λογαριασμό. Αντιγράψτε τα δεδομένα για τη μεταφορά. Είναι σημαντικό τα δεδομένα να είναι ίδια, να μην αλλάζετε το ποσό, το νόμισμα, τον τίτλο κ.λπ. ',
      verifyInfo: 'Η επαλήθευση για την τράπεζά σας ενδέχεται να διαρκέσει έως και 3 ημέρες λόγω αδυναμίας επεξεργασίας μιας γρήγορης μεταφοράς. Μπορείτε να συνεχίσετε ή μπορείτε να επαληθεύσετε τον τραπεζικό σας λογαριασμό με άλλο τρόπο. Εάν θέλετε να επιλέξετε διαφορετική μέθοδο, κάντε κλικ <strong>{backToShopText}</strong> και επιστρέψτε στον ιστότοπο της Fortuna.'
    },
    frInfo: {
      paywall: {
        text1: 'Πληρώνετε από λογαριασμό εξωτερικού;',
        text2: 'Βεβαιωθείτε ότι το ποσό και ο τίτλος μεταφοράς συμφωνούν με τα στοιχεία που παρέχονται. Συμπεριλάβετε τις χρεώσεις της τράπεζάς σας. Διαφορετικά στοιχεία ενδέχεται να εμποδίσουν την επεξεργασία της πληρωμής.'
      },
      frData: {
        text1: 'Παρακαλώ εισάγετε τα στοιχεία ακριβώς—χωρίς αλλαγές.',
        text2: 'Ένα διαφορετικό ποσό ή ΤΙΤΛΟΣ ΜΕΤΑΦΟΡΑΣ θα έχει ως αποτέλεσμα η πληρωμή να μην αντιστοιχιστεί στην παραγγελία.'
      }
    },
    processing: {
      pageTitle: 'Σελίδα αναμονής για την επεξεργασία της συναλλαγής',
      loaderAnimation: 'Κινούμενη εικόνα εμφανίζεται κατά τη διάρκεια της αναμονής',
      header: 'Προετοιμάζουμε τη σελίδα πληρωμής σας.',
      description: 'Περιμένετε λίγο ακόμα... ',
      info: {
        header: 'Θυμηθείτε !',
        description: 'Μην κλείσετε τη σελίδα μετά την ολοκλήρωση της συναλλαγής - αν το κάνετε, τα χρήματά σας δεν θα μεταφερθούν στον παραλήπτη '
      },
      loaderText: 'Μεταφορά δεδομένων σε εξέλιξη.<br>Θα μας πάρει το πολύ 30 δευτερόλεπτα.'
    }
  },
  thankYou: {
    pageTitle: 'Πληροφορίες αποτελέσματος συναλλαγής ',
    form: {
      emailLabel: 'E-mail',
      buttonSubmit: 'Επιστροφή στη σελίδα του συνεργάτη '
    },
    negative: {
      header: 'Η πληρωμή δεν ολοκληρώθηκε λόγω έλλειψης έγκρισης της συναλλαγή.',
      description: 'Αν θέλετε ακόμα να επωφεληθείτε από την προσφορά του συγκεκριμένου πωλητή ή παρόχου υπηρεσιών - επιστρέψτε στην ιστοσελίδα του, επιλέξτε ένα προϊόν ή μια υπηρεσία και κάντε την πληρωμή χρησιμοποιώντας τη μέθοδο που επιλέξατε.'
    },
    pending: {
      header: 'Ευχαριστούμε για την εντολή πληρωμής μέσω πύλης πληρωμών.',
      description: 'Ελέγχεται ο κατάσταση της συναλλαγής. Όταν ολοκληρωθεί η διαδικασία, θα λάβετε ειδοποίηση για την κατάσταση της πληρωμής στο ηλεκτρονικό ταχυδρομείο σας.'
    },
    positive: {
      header: 'Σας ευχαριστούμε, η πληρωμή σας ολοκληρώθηκε.',
      description: 'Θα στείλουμε την επιβεβαίωση στην ηλεκτρονική σας διεύθυνσ.'
    }
  },
  regulationsApproval: {
    header: 'Εγκρίνετε τη συναλλαγή '
  },
  wait: {
    pageTitle: 'Σελίδα αναμονής '
  },
  sessionTimeout: {
    pageTitle: 'Σελίδα μετά το πέρας της συνεδρίας ',
    header: 'Ο χρόνος για την ολοκλήρωση της πληρωμής έληξε.',
    description: 'Μπορείτε να επιστρέψετε οποτεδήποτε στη σελίδα του εταίρου, να κάνετε ξανά παραγγελία ή να χρησιμοποιήσετε την υπηρεσία και να κάνετε πληρωμή χρησιμοποιώντας τη μέθοδο που επιλέξατε.'
  },
  paywayError: {
    pageTitle: 'Επιλεγμένος τρόπος πληρωμής μη διαθέσιμος ',
    header: 'Δυστυχώς ο επιλεγμένος τρόπος πληρωμής δεν είναι αυτή τη στιγμή διαθέσιμος.',
    description: 'Επιστρέψτε στη σελίδα του συνεργάτη και δοκιμάστε ξανά αργότερα.'
  },
  loader: {
    loading: 'Φόρτωση',
    defaultAnimation: 'Κινούμενη εικόνα που εμφανίζεται κατά τη φόρτωση της σελίδας',
    slider: 'Διαδοχή κειμένων με κινούμενη εικόνα',
    text1: 'Στην Autopay προσπαθούμε να είμαστε άνθρακας-αρνητικοί. Κάνετε και εσείς το ίδιο χρησιμοποιώντας τις υπηρεσίες μας.',
    text2: 'Στην Autopay πηγαίνουμε στη δουλειά με ποδήλατα μειώνοντας τις εκπομπές αερίων του θερμοκηπίου στην ατμόσφαιρα. Κάνετε και εσείς το ίδιο χρησιμοποιώντας τις υπηρεσίες μας.',
    text3: 'Στην Autopay τροφοδοτούμαστε από πράσινη ενέργεια.<br>Και εσείς τροφοδοτείστε όταν χρησιμοποιείτε τις υπηρεσίες μας.',
    text4: 'Στην Autopay περιορίζουμε τη χρήση χαρτιού. Κάνετε και εσείς το ίδιο χρησιμοποιώντας τις υπηρεσίες μας..',
    rateLimitExceeded: 'Υπάρχει αυξημένη κίνηση συναλλαγών, επομένως η επεξεργασία της πληρωμής σας μπορεί να διαρκέσει περισσότερο από το συνηθισμένο. Παρακαλούμε περιμένετε και μην ανανεώσετε τη σελίδα πληρωμής.'
  },
  result: {
    pending: {
      header: 'Επιβεβαιώστε την επαναλαμβανόμενη πληρωμή BLIK',
      description: 'Ανοίξτε την τραπεζική σας εφαρμογή και επιβεβαιώστε την πληρωμή'
    },
    positive: {
      initWithPayment: {
        header: 'Πληρώθηκε',
        description: 'Έχουμε μεταφέρει τα χρήματά σας στον παραλήπτη. Η τελική επιβεβαίωση για την ενεργοποίηση της Επαναλαμβανόμενης Πληρωμής BLIK θα σας σταλεί από τον πωλητή ή την υπηρεσία παρόχου.',
        button: 'Επιστροφή στην ιστοσελίδα'
      },
      initWithRefund: {
        header: 'Έτοιμο',
        description1: 'Έχουμε λάβει την παραγγελία σας και την έχουμε προωθήσει για εκτέλεση. Η τελική επιβεβαίωση θα σας σταλεί απευθείας από το κατάστημα.',
        description2: 'Το ποσό {amount} {currency} θα επιστραφεί στον τραπεζικό σας λογαριασμό.',
        button: 'Επιστροφή στην ιστοσελίδα'
      },
      initWithoutPayment: {
        header: 'Έτοιμο',
        description: 'Ενεργοποιούμε επαναλαμβανόμενες πληρωμές BLIK. Σύντομα θα λάβετε ενημέρωση από {shopName}.',
        button: 'Επιστροφή στην ιστοσελίδα'
      }
    },
    negative: {
      recurrencyNotSupported: {
        header: 'Δεν είναι δυνατή η ενεργοποίηση της Επαναλαμβανόμενης Πληρωμής BLIK',
        description1: 'Δεν μπορείτε να ξεκινήσετε την Επαναλαμβανόμενη Πληρωμή BLIK. Αυτή η μέθοδος δεν είναι διαθέσιμη αυτή τη στιγμή για τους χρήστες της τράπεζάς σας.',
        description2: 'Δοκιμάστε ξανά χρησιμοποιώντας τον κωδικό BLIK σε υποστηριζόμενες τράπεζες ή επιλέξτε άλλη μέθοδο πληρωμής.',
        buttonContinue: 'Αλλαγή μεθόδου πληρωμής',
        buttonReturn: 'Επιστροφή στην ιστοσελίδα'
      },
      wrongTicket: {
        header: 'Λανθασμένος κωδικός BLIK',
        description: 'Ο εισαχθείς κωδικός BLIK είναι λανθασμένος ή έχει λήξει. Ελέγξτε αν τον γράψατε σωστά και δοκιμάστε ξανά. Εάν το πρόβλημα συνεχίζεται, δημιουργήστε νέο κωδικό στην τραπεζική εφαρμογή.',
        buttonContinue: 'Αλλαγή μεθόδου πληρωμής',
        buttonReturn: 'Επιστροφή στην ιστοσελίδα'
      },
      generic: {
        header: 'Δεν είναι δυνατή η ενεργοποίηση της Επαναλαμβανόμενης Πληρωμής BLIK',
        description: 'Δεν μπορείτε να ξεκινήσετε την Επαναλαμβανόμενη Πληρωμή BLIK. Δοκιμάστε ξανά χρησιμοποιώντας τον κωδικό BLIK σε υποστηριζόμενες τράπεζες ή επιλέξτε άλλη μέθοδο πληρωμής.',
        buttonContinue: 'Αλλαγή μεθόδου πληρωμής',
        buttonReturn: 'Επιστροφή στην ιστοσελίδα'
      }
    }
  },
  orderDetails: {
    header: 'Λεπτομέρειες ',
    headerAriaLabel: 'Λεπτομέρειες συναλλαγής ',
    amountLabel: 'Ποσό οφειλής ',
    receiverLabel: 'Παραλήπτης ',
    orderLabel: 'Αριθμός παραγγελίας ',
    amountOriginalCurrencyLabel: 'Αρχικό ποσό',
    currencyRateLabel: 'Συναλλαγματική ισοτιμία',
    feeLabel: 'Κόστος εκτέλεσης συναλλαγής',
    feeLabelDcc: 'Τέλος μετατροπής συναλλάγματος',
    customerNumberLabel: 'Αριθμός πελάτη ',
    invoiceNumberLabel: 'Αριθμός τιμολογίου ',
    accountNumberLabel: 'Αριθμός λογαριασμού ',
    paywayLabel: 'Μέθοδος πληρωμής ',
    paywayName: 'Διαδικτυακή μεταφορά',
    linkBack: 'Επιστροφή στο κατάστημα ',
    linkBackTitle: 'Ακύρωση συναλλαγής και επιστροφή στο κατάστημα',
    linkMore: 'περισσότερα',
    linkLess: 'λιγότερα',
    toggleBtnUnfoldAriaLabel: 'Ανάπτυξη λεπτομερειών παραγγελίας',
    toggleBtnFoldAriaLabel: 'Σύμπτυξη λεπτομερειών παραγγελίας',
    blikReccuringNameLabel: 'Όνομα',
    blikReccuringValidToLabel: 'Ημερομηνία λήξης',
    blikReccuringValidToText: 'Επ\' αόριστον',
    blikReccuringFrequencyLabel: 'Συχνότητα',
    blikReccuringFrequencyText: 'Κάθε φορά που χρησιμοποιείτε την υπηρεσία'
  },
  error: {
    pageTitle: 'Σελίδα με πληροφορίες σφάλματος',
    linkBackUrlSet: 'Επιστροφή στη σελίδα του συνεργάτη',
    linkBackUrlNotSet: 'Μετάβαση στη σελίδα βοήθειας',
    sessionTimeout: {
      title: 'Η περίοδος για ολοκλήρωση της πληρωμής έληξε',
      message: 'Μπορείτε ανά πάσα στιγμή να επιστρέψετε στη σελίδα του συνεργάτη, να κάνετε ξανά την παραγγελία σας ή να χρησιμοποιήσετε την υπηρεσία και να πραγματοποιήσετε την πληρωμή σας με την επιλεγμένη από εσάς μέθοδο.'
    },
    notFoundError: {
      pageTitle: 'Σελίδα με πληροφορίες σφάλματος 404 - η σελίδα δεν βρέθηκε',
      title: 'Φαίνεται ότι πήγατε πολύ μακριά και δεν ήταν δυνατή η εύρεση της σελίδας που προσπαθείτε να επισκεφθείτε.',
      message: 'Πιθανές αιτίες: η σελίδα δεν υπάρχει ή έχει διαγραφεί, διενεργούνται εργασίες συντήρησης, ο διεύθυνση της σελίδας είναι εσφαλμένη, παρουσιάστηκε τεχνικό σφάλμα.'
    },
    generalError: {
      title: 'Λυπούμαστε',
      message: 'Προς το παρόν δεν είμαστε σε θέση να ολοκληρώσουμε τη μεταφορά σας.'
    },
    errFieldNotFound: {
      title: 'Λυπούμαστε',
      message: ''
    },
    errBadClientSource: {
      title: 'Λυπούμαστε',
      message: ''
    },
    nrParametersError: {
      title: 'Λυπούμαστε',
      message: 'Προς το παρόν δεν είμαστε σε θέση να ολοκληρώσουμε τη μεταφορά σας.'
    },
    transactionOutdated: {
      title: 'Ο χρόνος για την ολοκλήρωση της πληρωμής έληξε.',
      message: 'Κάντε την εκ νέου.'
    },
    linkValidityTimeOutdated: {
      title: 'Ο χρόνος για την ολοκλήρωση της πληρωμής έληξε.',
      message: 'Κάντε την εκ νέου.'
    },
    transactionValidityTimeOutdated: {
      title: 'Ο χρόνος για την ολοκλήρωση της πληρωμής έληξε.',
      message: 'Κάντε την εκ νέου.'
    },
    multiplyTransaction: {
      title: 'Λυπούμαστε',
      message: 'Η συναλλαγή υπάρχει ήδη και αναμένει πληρωμή.'
    },
    transactionCanceled: {
      title: 'Λυπούμαστε',
      message1: 'Η συναλλαγή ακυρώθηκε.',
      message2: 'Κάντε την εκ νέου.'
    },
    multiplyPaidTransaction: {
      title: 'Λυπούμαστε',
      message: 'Η συναλλαγή έχει ήδη πληρωθεί.'
    },
    transactionReject: {
      title: 'Λυπούμαστε',
      message1: 'Ούπς, κάτι πήγε στραβά.',
      message2: 'Διορθώνουμε ήδη την πύλη...'
    },
    bankDisabled: {
      title: 'Λυπούμαστε',
      message: 'Η επιλεγμένη τράπεζα δεν είναι αυτή τη στιγμή διαθέσιμη.'
    },
    bankTemporaryMaintenance: {
      title: 'Λυπούμαστε',
      message: 'Προς το παρόν δεν μπορούμε να ολοκληρώσουμε τη συναλλαγή σας.'
    },
    insufficientStartAmount: {
      title: 'Λυπούμαστε',
      message: 'Υπερβαίνεται το όριο του ποσού της συναλλαγής.'
    },
    startAmountOutOfRange: {
      title: 'Λυπούμαστε',
      message: 'Υπερβαίνεται το όριο του ποσού της συναλλαγής.'
    },
    nonAccountedLimitExceeded: {
      title: 'Λυπούμαστε',
      message: 'Η πληρωμή δεν μπορεί να πραγματοποιηθεί επειδή ο πωλητής έχει ξεπεράσει τον μη λογιστικό μηνιαίο του όριο πωλήσεων.'
    }
  },
  confirmation: {
    pageTitle: 'Πληροφορίες για την πορεία της πληρωμής',
    linkBack: 'Επιστροφή στη σελίδα',
    linkBackTimeout: 'Επιστροφή στη σελίδα του συνεργάτη σε ',
    linkBackTimeoutTime: 'δευτερόλεπτα',
    linkBackAutoRedirect: 'Αυτή η σελίδα θα ανακατευθυνθεί αυτόματα στον ιστότοπο του συνεργάτη σε {time} δευτερόλεπτα. Η αλληλεπίδραση με τη σελίδα θα σταματήσει την αντίστροφη μέτρηση.',
    linkBackTimerStopped: 'Η αυτόματη ανακατεύθυνση σταμάτησε. Για να επιστρέψετε στον ιστότοπο του συνεργάτη, χρησιμοποιήστε το κουμπί Επιστροφή στον ιστότοπο.',
    incorrectAmount: {
      header: 'Λάθος ποσό',
      description: 'Δεν μεταφέραμε την πληρωμή σας στον παραλήπτη επειδή το ποσό δεν ταίριαζε.',
      description2: 'Κάντε κλικ στο κουμπί για να επιστρέψετε στη σελίδα και να την επαναλάβετε. Θυμηθείτε να μην αλλάξετε καμία πληροφορία.'
    },
    multiplePaid: {
      header: 'Διπλή πληρωμή',
      description: 'Ο παραλήπτης έλαβε την πληρωμή σας δύο φορές. Μην ανησυχείτε - θα λάβετε επιστροφή.',
      description2: 'Επικοινωνήστε με τον παραλήπτη και δώστε του την επιβεβαίωση πληρωμής.'
    },
    negative: {
      header: 'Απουσία πληρωμής',
      description: 'Κατά τη διάρκεια της επεξεργασίας της πληρωμής σας παρουσιάστηκε σφάλμα. Ωστόσο, δεν έχετε χάσει τίποτα.',
      description2: 'Κάντε κλικ στο κουμπί για να επιστρέψετε στη σελίδα και να την επαναλάβετε.'
    },
    notFound: {
      header: 'Απουσία πληρωμής',
      description: 'Κατά τη διάρκεια της επεξεργασίας της πληρωμής σας παρουσιάστηκε σφάλμα. Ωστόσο, δεν έχετε χάσει τίποτα.',
      description2: 'Κάντε κλικ στο κουμπί για να επιστρέψετε στη σελίδα και να την επαναλάβετε.'
    },
    outdated: {
      header: 'Λήξη χρόνου',
      description: 'Δεν μεταφέραμε την πληρωμή σας στον παραλήπτη.',
      description2: 'Κάντε κλικ στο κουμπί για να επιστρέψετε στη σελίδα και να την επαναλάβετε.'
    },
    outdatedPaidNotRefunded: {
      header: 'Λήξη χρόνου',
      description: 'Δεν μεταφέραμε την πληρωμή σας στον παραλήπτη. Αν τα χρήματα έχουν ήδη χρεωθεί από τον λογαριασμό σας - μην ανησυχείτε, θα λάβετε επιστροφή μέσα σε λίγες ημέρες.',
      description2: 'Κάντε κλικ στο κουμπί για να επιστρέψετε στη σελίδα και να την επαναλάβετε.'
    },
    outdatedPaidRefunded: {
      header: 'Λήξη χρόνου',
      description: 'Δεν μεταφέραμε την πληρωμή σας στον παραλήπτη. Αν τα χρήματα έχουν ήδη χρεωθεί από τον λογαριασμό σας - μην ανησυχείτε, τα έχουμε ήδη επιστρέψει.',
      description2: 'Κάντε κλικ στο κουμπί για να επιστρέψετε στη σελίδα και να την επαναλάβετε.'
    },
    pending: {
      header: 'Εκκρεμής ',
      description: 'Εκτελούμε την πληρωμή σας. Θα σας ενημερώσουμε όταν φτάσει στον παραλήπτη.'
    },
    positive: {
      header: 'Πληρώθηκε ',
      visaVideo: 'Διαφημιστικό βίντεο που προβάλλεται μετά από επιτυχή συναλλαγή',
      description: 'Μεταφέραμε τα χρήματά σας στον παραλήπτη.',
      dccStatement: 'Μου δόθηκε η ευκαιρία να επιλέξω τα νομίσματα που θα χρησιμοποιηθούν για την πληρωμή μου. Επέλεξα το νόμισμα συναλλαγής και συμφώνησα να πληρώσω σε {currency} με την αναγραφόμενη συναλλαγματική ισοτιμία. Η δυναμική μετατροπή νομίσματος (DCC) παρέχεται από την Autopay S.A.'
    }
  },
  messages: {
    accessForbidden: 'Δεν υπάρχει πρόσβαση',
    internalServerError: 'Παρουσιάστηκε απροσδόκητο σφάλμα. Δοκιμάστε ξανά αργότερα.',
    validators: {
      required: 'Υποχρεωτικό πεδίο',
      pattern: 'Καταχωρίστε μια έγκυρη τιμή',
      blikCode: 'Εισάγετε τον 6-ψήφιο κωδικό BLIK',
      emailRequired: 'Εισάγετε μια έγκυρη διεύθυνση email',
      emailNotValid: 'Εισάγετε μια έγκυρη διεύθυνση email',
      emailNotRecognized: 'Η διεύθυνση email που καταχωρίσατε δεν είναι εγγεγραμμένη',
      emailIdentityLookup: 'Αδυναμία επαλήθευσης της διεύθυνσης email',
      emailLocked: 'Η διεύθυνση email που καταχωρίσατε είναι προσωρινά κλειδωμένη στο σύστημα Mastercard',
      paywayRequired: 'Για να πραγματοποιήσετε πληρωμή, επιλέξτε την τράπεζα',
      creditCardRequired: 'Συμπληρώστε όλα τα πεδία',
      phoneRequired: 'Εισάγετε μια έγκυρη αριθμό τηλεφώνου',
      regulationRequired: 'Αποδοχή των ρυθμίσεων απαιτείται',
      requiredConsent: 'Απαιτείται συγκατάθεση',
      codeNotValid: 'Ο κωδικός που καταχωρίσατε δεν είναι έγκυρος',
      codeAccountLocked: 'Το λογαριασμός έχει κλειδωθεί προσωρινά',
      unknownError: 'Παρουσιάστηκε απροσδόκητο σφάλμα'
    },
    validatorsAria: {
      required: 'Προσοχή. Το πεδίο της φόρμας δεν έχει συμπληρωθεί. Υποχρεωτικό πεδίο ',
      pattern: 'Προσοχή. Το πεδίο περιέχει μια μη έγκυρη τιμή.',
      blikCode: 'Προσοχή. Εισάγετε τον 6-ψήφιο κωδικό BLIK',
      emailRequired: 'Προσοχή. Το πεδίο email δεν έχει συμπληρωθεί. Εισάγετε μια έγκυρη διεύθυνση email.',
      emailNotValid: 'Προσοχή. Η διεύθυνση email που καταχωρίσατε περιέχει σφάλμα. Εισάγετε μια έγκυρη διεύθυνση email ',
      emailNotRecognized: 'Προσοχή. Η διεύθυνση email που καταχωρίσατε δεν είναι εγγεγραμμένη.',
      emailIdentityLookup: 'Προσοχή. Αδυναμία επαλήθευσης της διεύθυνσης email',
      emailLocked: 'Προσοχή. Η διεύθυνση email που καταχωρίσατε είναι προσωρινά κλειδωμένη στο σύστημα Mastercard.',
      paywayRequired: 'Προσοχή. Δεν έχει επιλεγεί πληρωμή. Επιλέξτε μια μέθοδο πληρωμής.',
      creditCardRequired: 'Προσοχή. Συμπληρώστε όλα τα πεδία με τα δεδομένα της πιστωτικής κάρτας. ',
      phoneRequired: 'Προσοχή. Το πεδίο αριθμού τηλεφώνου περιέχει σφάλμα. Εισάγετε έναν έγκυρο αριθμό τηλεφώνου ',
      codeNotValid: 'Προσοχή. Ο κωδικός που καταχωρίσατε δεν είναι έγκυρος. ',
      codeAccountLocked: 'Προσοχή. Ο λογαριασμός έχει κλειδωθεί προσωρινά.',
      unknownError: 'Προσοχή. Παρουσιάστηκε απροσδόκητο σφάλμα.'
    },
    success: {
      copy: 'Αντιγράφηκε!',
      codeSent: 'Ο κωδικός εστάλη!'
    },
    errors: {
      getPdf: 'Απέτυχε η λήψη του αρχείου PDF !',
      copy: 'Απέτυχε η αντιγραφή !',
      thankYouUpdate: 'Απέτυχε η αποθήκευση της διεύθυνσης email!',
      groupInactive: 'Προς το παρόν, η εκτέλεση μιας μεταφοράς μέσω της ομάδας {groupName} δεν είναι δυνατή. Επιλέξτε μια άλλη μέθοδο πληρωμής.',
      paywayInactive: 'Προς το παρόν, η εκτέλεση μιας μεταφοράς από την επιλεγμένη τράπεζα δεν είναι δυνατή. Επιλέξτε μια άλλη τράπεζα ή μέθοδο πληρωμής.',
      googlePayInactive: 'Δυστυχώς, η πληρωμή Google Pay δεν είναι διαθέσιμη στη συσκευή σας.',
      applePayInactive: 'Η πληρωμή Apple Pay είναι διαθέσιμη για χρήστες που χρησιμοποιούν τον περιηγητή Safari και συσκευές με λειτουργικό σύστημα iOS.',
      codeNotSent: 'Απέτυχε η αποστολή του κωδικού ξανά! ',
      codeCounterExceeded: 'Υπερβέθηκε το επιτρεπόμενο όριο προσπαθειών. Καταχωρήστε τα δεδομένα της κάρτας χειροκίνητα ή χρησιμοποιήστε μια διαφορετική μέθοδο πληρωμής.'
    }
  },
  modal: {
    closeButton: 'Κλείσιμο ',
    confirmButton: 'Κατάλαβα '
  },
  configuration: {
    paywayGroups: {
      auto: {
        label: 'Αυτόματη πληρωμή ',
        description: 'Καταχωρίστε τα στοιχεία της κάρτας που θα χρησιμοποιήσετε για τις πληρωμές. Οι αυτόματες πληρωμές θα πραγματοποιούνται από την κάρτα σας στο μέλλον.',
        labelInitWithRefund: 'Επιβεβαιωτική πληρωμή ',
        labelInitWithRefundOrange: 'Προσθήκη πιστωτικής κάρτας ',
        labelInitWithPayment: 'Πληρωμή με κάρτα',
        descriptionInitWithRefund: 'Καταχωρίστε τα στοιχεία της κάρτας που θέλετε να επιβεβαιώσετε για μελλοντικές πληρωμές. Στο επόμενο βήμα, θα χρεωθείτε με ένα ευρώ από την καταχωρημένη κάρτα για τον έλεγχο των δεδομένων. Μετά την επιβεβαίωση, το ποσό θα επιστραφεί.',
        descriptionInitWithPayment: 'Καταχωρίστε τα στοιχεία της κάρτας με την οποία θα πραγματοποιήσετε τη συναλλαγή και ταυτόχρονα θα την επιβεβαιώσετε για μελλοντικές πληρωμές.'
      },
      blik: {
        label: 'BLIK',
        description: 'Πληρώστε άμεσα εισάγοντας τον κωδικό BLIK, χωρίς σύνδεση και εγγραφή'
      },
      blikAuto: {
        label: 'BLIK επαναλαμβανόμενες πληρωμές',
        description: 'Μπορείτε να ενεργοποιήσετε επαναλαμβανόμενες πληρωμές BLIK για αυτόν τον έμπορο και οι επόμενες πληρωμές θα χρεώνονται αυτόματα από τον λογαριασμό σας.'
      },
      card: {
        label: 'Πληρωμή με κάρτα ',
        description: 'Πληρώστε με την πιστωτική σας κάρτα '
      },
      pbl: {
        label: 'Διαδικτυακή μεταφορά ',
        description: 'Επιλέξτε την τράπεζα από την οποία θέλετε να κάνετε την πληρωμή ',
        descriptionVerify: 'Έλεγχος ταυτότητας online ',
        descriptionServiceVerify: 'Επιλέξτε την τράπεζα με την οποία θα πραγματοποιήσετε την επαλήθευση της διαδικτυακής υπηρεσίας'
      },
      visaMobile: {
        label: 'Visa Mobile',
        description: 'Πληρώστε με την εφαρμογή Visa Mobile '
      },
      wallet: {
        label: 'Google&nbsp;Pay | Apple&nbsp;Pay',
        description: 'Πληρώστε χωρίς να χρειάζεται να συνδεθείτε στην ηλεκτρονική τραπεζική'
      },
      installments: {
        label: 'Δόσεις ',
        description: 'Πληρώστε τις αγορές σας με εύκολες δόσεις'
      },
      alior: {
        descriptionInfo1: 'Πληρώστε τις αγορές σας με εύκολες δόσεις.',
        descriptionInfo2: '(ελέγξτε τις λεπτομέρειες) ',
        aliorModal: {
          text1: 'Ανάλογα με τις ρυθμίσεις του σετ που χρησιμοποιείτε, έχετε τη δυνατότητα να αγοράζετε προϊόντα με τις ακόλουθες επιλογές δόσεων: ',
          text2: '<ul><li>10 δόσεις 0%</li><li>20 δόσεις 0%</li><li>από 3 έως 48 δόσεις με μηνιαίο κόστος 1% (σύμφωνα με το αντιπροσωπευτικό παράδειγμα που δίνεται για μια δεδομένη συναλλαγή)</li></ul>'
        }
      },
      otp: {
        label: 'Πλήρωσε αργότερα',
        description: 'Αγοράστε τώρα πληρώστε αργότερα ',
        descriptionInfo1Mwf: 'Πληρώστε αργότερα το λογαριασμό σας - έως 45 ημέρες κάθε φορά ή σε πολλές ισόποσες δόσεις ',
        descriptionInfo1Ecommerce: 'Πληρώστε αργότερα - έως 45 ημέρες κάθε φορά ή σε πολλές ισόποσες δόσεις',
        descriptionInfo2Mwf: 'Πληροφορίες για το μεσίτη πίστωσης και τα κόστη ',
        descriptionInfo2Ecommerce: 'Πληροφορίες κόστους',
        labelPayka: 'Payka',
        descriptionPayka: 'Πληρώστε αργότερα τον λογαριασμό – μία φορά έως 30 ημέρες ή σε 4 ίσες δόσεις <a href="" id="paykaShowInModal">Πληροφορίες για τον μεσίτη πιστώσεων και το κόστος</a>',
        paykaModalMwf: {
          header1: 'Πληροφορίες για τον μεσίτη πίστωσης ',
          text1: 'Η Autopay S.A., με έδρα στο Sopot, ενεργεί ως μεσίτης δανείων για την Paytree S.A., με έδρα στο Γκντανσκ της Πολωνίας (Δανειστής), εξουσιοδοτημένη να παρουσιάζει την προσφορά δανείου στους πελάτες και να ανακατευθύνει στον ιστότοπο του δανειστή, συμπεριλαμβανομένης της αίτησης δανείου. Για λεπτομέρειες σχετικά με την προσφορά, επισκεφθείτε: <a href="https://payka.pl/rachunki-domowe" target="_blank">Οικοκυρικοί λογαριασμοί – Payka</a>.',
          header2: 'Στοιχεία Κόστους ',
          text2: 'Πληρώστε αργότερα - μία φορά έως και 45 ημέρες ή σε πολλές ισόποσες δόσεις. Στοιχεία κόστους για ένα αντιπροσωπευτικό παράδειγμα: Εξόφληση εντός 45 ημερών APR 0%. Αποπληρωμή δόσεων ΑΠΡ 74,11%. Αναλυτικά η προσφορά στο: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        },
        paykaModalEcommerce: {
          header2: 'Στοιχεία κόστους',
          text2: 'Πληρώστε αργότερα - μία φορά έως και 45 ημέρες ή σε πολλές ισόποσες δόσεις. Στοιχεία κόστους για ένα αντιπροσωπευτικό παράδειγμα: Εξόφληση εντός 45 ημερών APR 0%. Αποπληρωμή δόσεων ΑΠΡ 74,11%. Αναλυτικά η προσφορά στο: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        }
      },
      blikPayLater: {
        label: 'BLIK Πληρώστε αργότερα',
        description: ''
      },
      companyPayments: {
        label: 'Εταιρικές Πληρωμές ',
        description: 'Μετακίνηση της ημερομηνίας πληρωμής για εταιρικές αγορές κατά 30 ημέρες'
      },
      transfer: {
        label: 'Στοιχεία Μεταφοράς ',
        description: 'Δώστε εντολή για μεταφορά χρημάτων χρησιμοποιώντας τα παρακάτω στοιχεία'
      },
      other: {
        label: 'Άλλα',
        description: ''
      }
    },
    mobileEvents: {
      statusDescription: {
        bankDisabled: 'Λυπούμαστε. Προς το παρόν δεν είμαστε σε θέση να εκτελέσουμε τη μεταφορά σας. Η τράπεζα που επιλέξατε δεν είναι διαθέσιμη αυτήν τη στιγμή ',
        blockMultipleTransactions: 'Λυπούμαστε. Η συναλλαγή υπάρχει ήδη και περιμένει για πληρωμή.',
        blockPaidTransactions: 'Λυπούμαστε. Η συναλλαγή έχει ήδη πληρωθεί. Δεν είναι δυνατή η εκτέλεση πληρωμής ξανά.',
        canceledTransactions: 'Η συναλλαγή που προσπαθείτε να πληρώσετε έχει ακυρωθεί και δεν είναι διαθέσιμη. Παρακαλούμε ξεκινήστε μια νέα συναλλαγή.',
        declined: 'Άρνηση έγκρισης.',
        generalError: 'Προέκυψε προσωρινό πρόβλημα με τη σύνδεση. Αυτήν τη στιγμή δεν μπορούμε να εκτελέσουμε τη μεταφορά σας. Παρακαλούμε δοκιμάστε αργότερα.',
        insufficientStartAmount: 'Λυπούμαστε. Ο περιορισμός του ποσού μεταφοράς έχει υπερβείτε.',
        internalServerError: 'Ωχ.. κάτι πήγε στραβά :(. Εργαζόμαστε για την επίλυση του προβλήματος. Παρακαλούμε δοκιμάστε ξανά αργότερα.',
        nonAccountedLimitExceeded: 'Η πληρωμή δεν μπορεί να πραγματοποιηθεί, καθώς ο πωλητής έχει φτάσει το μηνιαίο όριο πωλήσεων.',
        outdatedError: 'Ο χρόνος για την ολοκλήρωση της πληρωμής έχει λήξει..',
        paid: 'Η συναλλαγή ολοκληρώθηκε επιτυχώς.',
        paywayLoaded: 'Η σελίδα ταχείας μεταφοράς φορτώθηκε ',
        paywaylistLoaded: 'Η σελίδα επιλογής μεθόδων πληρωμής φορτώθηκ '
      }
    }
  },
  maintenance: {
    text1: 'Γίνονται καθαρισμοί της πύλης πληρωμών της Autopay για τη νέα χρονιά, επομένως η εντολή πληρωμής είναι αδύνατη αυτήν τη στιγμή. Ζητούμε συγνώμη για την ταλαιπωρία..',
    text2: 'Η πύλη θα λειτουργήσει ξανά στις 16 Ιανουαρίου στις 10:00.',
    text3: 'Σας ευχαριστούμε για την κατανόηση.'
  },
  requiredParams: {
    accountHolderName: {
      label: 'Εισαγάγετε το όνομα και το επώνυμό σας',
      flowLabel: 'Όνομα και επώνυμο',
      placeholder: 'Εισαγάγετε το όνομα και το επώνυμό σας'
    },
    nip: {
      label: 'Εισαγάγετε τον αριθμό φορολογικού μητρώου σας',
      flowLabel: 'ΑΦΜ',
      placeholder: 'Εισαγάγετε τον αριθμό φορολογικού μητρώου σας'
    },
    customerEmail: {
      label: 'Εισαγάγετε τη διεύθυνση email σας',
      flowLabel: 'Διεύθυνση email',
      placeholder: 'Εισαγάγετε τη διεύθυνση email σας'
    },
    senderIban: {
      label: 'Συμπληρώστε το IBAN σας',
      flowLabel: 'IBAN',
      placeholder: 'Συμπληρώστε το IBAN σας'
    },
    shippingBuildingNumber: {
      label: 'Εισαγάγετε αριθμό κτηρίου',
      flowLabel: 'Αρ. κτηρίου',
      placeholder: 'Αρ. κτηρίου'
    },
    shippingPostalCode: {
      label: 'Εισαγάγετε ταχυδρομικό κώδικα',
      flowLabel: 'Τ.Κ.',
      placeholder: 'Τ.Κ.'
    },
    shippingStreetName: {
      label: 'Εισαγάγετε οδό',
      flowLabel: 'Οδός',
      placeholder: 'Οδός'
    },
    shippingLastName: {
      label: 'Εισαγάγετε επώνυμο',
      flowLabel: 'Επώνυμο',
      placeholder: 'Επώνυμο'
    },
    shippingCountryCode: {
      label: 'Εισαγάγετε χώρα',
      flowLabel: 'Χώρα',
      placeholder: 'επιλέξτε χώρα'
    },
    shippingRegion: {
      label: 'Εισαγάγετε περιοχή',
      flowLabel: 'Περιοχή',
      placeholder: 'Περιοχή'
    },
    shippingFlatNumber: {
      label: 'Εισαγάγετε αριθμό διαμερίσματος',
      flowLabel: 'Αρ. διαμ.',
      placeholder: 'Αρ. διαμ.'
    },
    shippingFirstName: {
      label: 'Εισαγάγετε όνομα',
      flowLabel: 'Όνομα',
      placeholder: 'Όνομα'
    },
    shippingCity: {
      label: 'Εισαγάγετε πόλη',
      flowLabel: 'Πόλη',
      placeholder: 'Πόλη'
    }
  },
  survey: {
    skipSurvey: 'Παράλειψη έρευνας',
    skipSurveyLabel: 'Παράλειψη ενότητας έρευνας',
    sectionLabel: 'Έρευνα'
  }
}
